export interface ProfileHeaderViewData {
  displayName: string;
  displayUsername: string;
  displayBalance: number;
  profilePhotoUrl?: string;
}

interface BuildProfileHeaderInput {
  displayName: string;
  displayUsername?: string;
  fallbackUsername: string;
  balance?: number | null;
  fallbackBalance?: number;
  profilePhotoUrl?: string;
}

export class ProfileOverviewController {
  buildHeaderViewData(input: BuildProfileHeaderInput): ProfileHeaderViewData {
    return {
      displayName: input.displayName,
      displayUsername: input.displayUsername ? `@${input.displayUsername}` : input.fallbackUsername,
      displayBalance: input.balance ?? input.fallbackBalance ?? 0,
      profilePhotoUrl: input.profilePhotoUrl,
    };
  }
}
